/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $ListProfessionSpecialtiesRequest = {
  properties: {
    professionId: {
      type: 'string',
      isRequired: true,
    },
  },
} as const;
